import { root, id } from './clear';

export const clear = {
  ...root,
  id,
};
